import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { EnumType11cgb4df0n5r9 as EnumType } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  AvatarType_Retro_instance = new (AvatarType())('Retro', 0, 'Retro');
  AvatarType_RobohashSet1_instance = new (AvatarType())('RobohashSet1', 1, 'RobohashSet1');
  AvatarType_RobohashSet2_instance = new (AvatarType())('RobohashSet2', 2, 'RobohashSet2');
  AvatarType_RobohashSet3_instance = new (AvatarType())('RobohashSet3', 3, 'RobohashSet3');
  AvatarType_RobohashSet4_instance = new (AvatarType())('RobohashSet4', 4, 'RobohashSet4');
  AvatarType_RobohashSet5_instance = new (AvatarType())('RobohashSet5', 5, 'RobohashSet5');
  AvatarType_Multiavatar_instance = new (AvatarType())('Multiavatar', 6, 'Multiavatar');
  AvatarType_DicebearPixelArt_instance = new (AvatarType())('DicebearPixelArt', 7, 'DicebearPixelArt');
  AvatarType_DicebearAdventurer_instance = new (AvatarType())('DicebearAdventurer', 8, 'DicebearAdventurer');
  AvatarType_DicebearCroodles_instance = new (AvatarType())('DicebearCroodles', 9, 'DicebearCroodles');
  AvatarType_DicebearThumbs_instance = new (AvatarType())('DicebearThumbs', 10, 'DicebearThumbs');
  AvatarType_DicebearLorelei_instance = new (AvatarType())('DicebearLorelei', 11, 'DicebearLorelei');
  AvatarType_UNKNOWN___instance = new (AvatarType())('UNKNOWN__', 12, 'UNKNOWN__');
  if (Companion_instance_0 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var AvatarType_Retro_instance;
var AvatarType_RobohashSet1_instance;
var AvatarType_RobohashSet2_instance;
var AvatarType_RobohashSet3_instance;
var AvatarType_RobohashSet4_instance;
var AvatarType_RobohashSet5_instance;
var AvatarType_Multiavatar_instance;
var AvatarType_DicebearPixelArt_instance;
var AvatarType_DicebearAdventurer_instance;
var AvatarType_DicebearCroodles_instance;
var AvatarType_DicebearThumbs_instance;
var AvatarType_DicebearLorelei_instance;
var AvatarType_UNKNOWN___instance;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.type_1 = new (EnumType())('AvatarType', listOf(['Retro', 'RobohashSet1', 'RobohashSet2', 'RobohashSet3', 'RobohashSet4', 'RobohashSet5', 'Multiavatar', 'DicebearPixelArt', 'DicebearAdventurer', 'DicebearCroodles', 'DicebearThumbs', 'DicebearLorelei']));
      }
      safeValueOf_kvndq9_k$(rawValue) {
        switch (rawValue) {
          case 'Retro':
            return AvatarType_Retro_getInstance();
          case 'RobohashSet1':
            return AvatarType_RobohashSet1_getInstance();
          case 'RobohashSet2':
            return AvatarType_RobohashSet2_getInstance();
          case 'RobohashSet3':
            return AvatarType_RobohashSet3_getInstance();
          case 'RobohashSet4':
            return AvatarType_RobohashSet4_getInstance();
          case 'RobohashSet5':
            return AvatarType_RobohashSet5_getInstance();
          case 'Multiavatar':
            return AvatarType_Multiavatar_getInstance();
          case 'DicebearPixelArt':
            return AvatarType_DicebearPixelArt_getInstance();
          case 'DicebearAdventurer':
            return AvatarType_DicebearAdventurer_getInstance();
          case 'DicebearCroodles':
            return AvatarType_DicebearCroodles_getInstance();
          case 'DicebearThumbs':
            return AvatarType_DicebearThumbs_getInstance();
          case 'DicebearLorelei':
            return AvatarType_DicebearLorelei_getInstance();
          default:
            return AvatarType_UNKNOWN___getInstance();
        }
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  static_init();
  return Companion_instance_0;
}
var AvatarTypeClass;
function AvatarType() {
  if (AvatarTypeClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, rawValue) {
        super(name, ordinal);
        this.rawValue_1 = rawValue;
      }
    }
    initMetadataForClass($, 'AvatarType');
    AvatarTypeClass = $;
  }
  return AvatarTypeClass;
}
function AvatarType_Retro_getInstance() {
  static_init();
  return AvatarType_Retro_instance;
}
function AvatarType_RobohashSet1_getInstance() {
  static_init();
  return AvatarType_RobohashSet1_instance;
}
function AvatarType_RobohashSet2_getInstance() {
  static_init();
  return AvatarType_RobohashSet2_instance;
}
function AvatarType_RobohashSet3_getInstance() {
  static_init();
  return AvatarType_RobohashSet3_instance;
}
function AvatarType_RobohashSet4_getInstance() {
  static_init();
  return AvatarType_RobohashSet4_instance;
}
function AvatarType_RobohashSet5_getInstance() {
  static_init();
  return AvatarType_RobohashSet5_instance;
}
function AvatarType_Multiavatar_getInstance() {
  static_init();
  return AvatarType_Multiavatar_instance;
}
function AvatarType_DicebearPixelArt_getInstance() {
  static_init();
  return AvatarType_DicebearPixelArt_instance;
}
function AvatarType_DicebearAdventurer_getInstance() {
  static_init();
  return AvatarType_DicebearAdventurer_instance;
}
function AvatarType_DicebearCroodles_getInstance() {
  static_init();
  return AvatarType_DicebearCroodles_instance;
}
function AvatarType_DicebearThumbs_getInstance() {
  static_init();
  return AvatarType_DicebearThumbs_instance;
}
function AvatarType_DicebearLorelei_getInstance() {
  static_init();
  return AvatarType_DicebearLorelei_instance;
}
function AvatarType_UNKNOWN___getInstance() {
  static_init();
  return AvatarType_UNKNOWN___instance;
}
//region block: exports
export {
  AvatarType as AvatarTypedvyblcabyk2y,
  Companion_getInstance as Companion_getInstance2z0tu3ig6w7km,
};
//endregion

//# sourceMappingURL=AvatarType.mjs.map
